var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/ui/hstack/hstack.tsx";
const _excluded = ["space", "alignItems", "grow", "justifyContent", "className"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import classNames from 'classnames';
import React, { forwardRef } from 'react';
const justifyContentOptions = {
  between: 'justify-between',
  center: 'justify-center',
  start: 'justify-start',
  end: 'justify-end',
  around: 'justify-around'
};
const alignItemsOptions = {
  top: 'items-start',
  bottom: 'items-end',
  center: 'items-center',
  start: 'items-start'
};
const spaces = {
  '0.5': 'space-x-0.5',
  1: 'space-x-1',
  1.5: 'space-x-1.5',
  2: 'space-x-2',
  3: 'space-x-3',
  4: 'space-x-4',
  6: 'space-x-6',
  8: 'space-x-8'
};
/** Horizontal row of child elements. */
const HStack = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      space,
      alignItems,
      grow,
      justifyContent,
      className
    } = props,
    filteredProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({}, filteredProps, {
    ref: ref,
    className: classNames('flex', {
      // @ts-ignore
      [alignItemsOptions[alignItems]]: typeof alignItems !== 'undefined',
      // @ts-ignore
      [justifyContentOptions[justifyContent]]: typeof justifyContent !== 'undefined',
      // @ts-ignore
      [spaces[space]]: typeof space !== 'undefined',
      'flex-grow': grow
    }, className),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52,
      columnNumber: 5
    }
  }));
});
export default HStack;